(()=>{if(window.__fltBundleBound)return;window.__fltBundleBound=true;
const form=()=>document.getElementById('flt-form'),root=()=>document.getElementById('flt-lp');
const parts=['cart-drawer','cart-icon-bubble'];
const base=(window.Shopify?.routes?.root||'/').replace(/\/?$/,'/');
function sync(){
  const f=form();if(!f)return;
  const id=f.querySelector('[name="id"]'),qty=f.querySelector('[name="quantity"]');
  if(id){const v=id.dataset.bundleVariantId||id.getAttribute('value');if(v)id.value=v;}
  if(qty)qty.value='1';
}
function buttons(f){return [...new Set([...f.querySelectorAll('button[type="submit"]'),...document.querySelectorAll('button[form="flt-form"][type="submit"]')])];}
async function request(url,options={},ms=10000){
  const c=new AbortController(),timer=setTimeout(()=>c.abort(),ms);
  try{return await fetch(url,{credentials:'same-origin',...options,signal:c.signal});}
  finally{clearTimeout(timer);}
}
async function cart(){
  const r=await request(base+'cart.js',{cache:'no-store'});
  if(!r.ok)throw Error('cart-read');return r.json();
}
function count(c,id){return(c.items||[]).reduce((n,i)=>n+(String(i.variant_id??i.id)===String(id)?Number(i.quantity)||0:0),0);}
function render(s){
  if(!s)return false;
  let updated=false,live=document.querySelector('cart-drawer');
  if(s['cart-drawer']&&live){
    const fresh=new DOMParser().parseFromString(s['cart-drawer'],'text/html').querySelector('cart-drawer');
    if(fresh){live.replaceWith(document.importNode(fresh,true));updated=true;}
  }
  const bubble=document.getElementById('cart-icon-bubble');
  if(s['cart-icon-bubble']&&bubble){
    const parsed=new DOMParser().parseFromString(s['cart-icon-bubble'],'text/html');
    bubble.innerHTML=(parsed.querySelector('.shopify-section')||parsed.body).innerHTML;
  }
  return updated;
}
async function refresh(){
  const url=new URL(location.pathname,location.origin);
  url.searchParams.set('sections',parts.join(','));
  const r=await request(url,{cache:'no-store'});
  return render(await r.json());
}
function open(){
  const d=document.querySelector('cart-drawer');
  if(d&&typeof d.open==='function')try{d.open();return;}catch(e){}
  location.assign(base+'cart');
}
async function add(id){
  const r=await request(base+'cart/add.js',{
    method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({items:[{id,quantity:1}],sections:parts,sections_url:location.pathname})
  },15000);
  const data=await r.json();
  if(!r.ok)throw {certain:r.status<500};
  return data;
}
async function submit(f,clicked){
  if(f.dataset.fltSubmitting)return;
  sync();
  const id=f.querySelector('[name="id"]')?.value;
  const all=buttons(f),prior=all.map(b=>b.disabled),b=clicked||all[0],label=b?.innerHTML;
  if(!id){if(b)b.textContent='حدّث الصفحة';return;}
  f.dataset.fltSubmitting='1';all.forEach(x=>x.disabled=true);
  let unknown=false,success=false;
  try{
    const before=count(await cart(),id);
    let data;
    try{data=await add(id);}
    catch(e){
      if(e.certain)throw e;
      let after;try{after=count(await cart(),id);}catch(readError){throw Error('unknown');}
      if(after<before+1)throw Error('unknown');
    }
    let ready=false;
    try{ready=render(data?.sections);}catch(e){}
    if(!ready)try{ready=await refresh();}catch(e){}
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
    document.dispatchEvent(new CustomEvent('cart:build',{bubbles:true}));
    success=true;
    if(b)b.textContent='تمت الإضافة ✓';
    setTimeout(()=>ready?open():location.assign(base+'cart'),150);
  }catch(e){
    unknown=e.message==='unknown';
    if(b)b.textContent=unknown?'افحص السلة أولاً':'حاول مجدداً';
  }finally{
    if(success)setTimeout(()=>{
      if(b)b.innerHTML=label;
      all.forEach((x,i)=>x.disabled=prior[i]);delete f.dataset.fltSubmitting;
    },2500);
    else{
      all.forEach((x,i)=>x.disabled=unknown||prior[i]);delete f.dataset.fltSubmitting;
      if(!unknown&&b)setTimeout(()=>b.innerHTML=label,4000);
    }
  }
}
document.addEventListener('submit',e=>{const f=form();if(e.target!==f)return;e.preventDefault();submit(f,e.submitter);});
document.addEventListener('click',e=>{if(e.target?.closest?.('.flt-wa-order'))sync();},true);
const installationState=new WeakMap();
function installationRoots(scope){
  return [...(scope?.matches?.('#pdp-installation')?[scope]:[]),...(scope?.querySelectorAll?.('#pdp-installation')||[])];
}
function initInstallation(scope=document){
  installationRoots(scope).forEach(section=>{
    if(installationState.has(section))return;
    const videos=[...section.querySelectorAll('video')];
    if(!videos.length)return;
    const motion=matchMedia('(prefers-reduced-motion: reduce)'),visibility=new WeakMap();
    function update(video,visible){
      visibility.set(video,visible);
      video.muted=true;
      if(motion.matches){video.pause();video.autoplay=false;video.controls=true;}
      else{video.autoplay=true;video.controls=false;if(visible)video.play().catch(()=>{video.controls=true;});else video.pause();}
    }
    const observer=new IntersectionObserver(entries=>entries.forEach(entry=>update(entry.target,entry.isIntersecting)),{threshold:.15});
    videos.forEach(video=>{const rect=video.getBoundingClientRect();update(video,rect.bottom>0&&rect.top<innerHeight);observer.observe(video);});
    const onMotionChange=()=>videos.forEach(video=>update(video,visibility.get(video)??(video.getBoundingClientRect().bottom>0&&video.getBoundingClientRect().top<innerHeight)));
    motion.addEventListener?.('change',onMotionChange);
    installationState.set(section,{observer,motion,onMotionChange,videos});
  });
}
function teardownInstallation(scope){
  installationRoots(scope).forEach(section=>{
    const state=installationState.get(section);if(!state)return;
    state.observer.disconnect();state.motion.removeEventListener?.('change',state.onMotionChange);
    state.videos.forEach(video=>video.pause());installationState.delete(section);
  });
}

let pending=false;
function sticky(){
  const p=root(),bar=p?.querySelector('#flt-sticky'),hero=p?.querySelector('#flt-form .hero button[type="submit"]');
  if(bar&&hero)bar.classList.toggle('show',hero.getBoundingClientRect().bottom<0);
}
function queue(){if(pending)return;pending=true;setTimeout(()=>{pending=false;sticky();},60);}
function init(scope=document){sync();sticky();initInstallation(scope);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
window.addEventListener('scroll',queue,{passive:true});
window.addEventListener('resize',queue,{passive:true});
document.addEventListener('shopify:section:load',event=>init(event.target));
document.addEventListener('shopify:section:unload',event=>teardownInstallation(event.target));
})();
